import { ADD_BRANCH, ADD_COUNSELOR, ADD_DIAGNOSIS, ADD_DOCTOR, ADD_MEDICAL, ADD_PACKAGE, ADD_PROBLEM, ADD_SERVICE, ADD_THERAPIST, ADMIN_DELETE, ADMIN_GET, ADMIN_SEARCH, ADMIN_UPDATE, ADMIN_USER, DELETE_BRANCH, DELETE_COUNSELOR, DELETE_DIAGNOSIS, DELETE_DOCTOR, DELETE_MEDICAL, DELETE_PACKAGE, DELETE_PROBLEM, DELETE_SERVICE, DELETE_THERAPIST, GET_BRANCH, GET_COUNSELOR, GET_DIAGNOSIS, GET_DOCTOR, GET_MEDICAL, GET_PACKAGE, GET_PROBLEM, GET_SERVICE, GET_THERAPIST, SEARCH_BRANCH, SEARCH_COUNSELOR, SEARCH_DIAGNOSIS, SEARCH_DOCTOR, SEARCH_MEDICAL, SEARCH_PACKAGE, SEARCH_PROBLEM, SEARCH_SERVICE, SEARCH_THERAPIST, UPDATE_BRANCH, UPDATE_COUNSELOR, UPDATE_DIAGNOSIS, UPDATE_DOCTOR, UPDATE_MEDICAL, UPDATE_PACKAGE, UPDATE_PROBLEM, UPDATE_SERVICE, UPDATE_THERAPIST, GET_INCOMING_CALL,SEARCH_INCOMING_CALL, } from "../actions/Master.action";

const initialState = {
    addProblem: '',
    updateProblem: '',
    getProblem: '',
    deleteProblem: '',
    addDocotr: '',
    getDoctor: '',
    deleteDoctor: '',
    updateDoctor: '',
    addMedical: '',
    getMedical: '',
    updateMedicial:'',
    deleteMedicial:'',
    addTherapist:'',
    getTherapist:'',
    updateTherapist:'',
    deleteTherapist:'',
    addBranch:'',
    getBranch:'',
    updateBranch:'',
    deleteBranch:'',
    addService:'',
    getService:'',
    updateService:'',
    deleteService:'',
    addCounselor:'',
    getCounselor:'',
    updateCounselor:'',
    deleteCounselor:'',
    addPackage:'',
    getPackage:'',
    updatePackage:'',
    deletePackage:'',
    adminUser:'',
    adminGet:'',
    adminUpdate:'',
    adminDelete:'',
    addDiagnosis:'',
    getDiagnosis:'',
    updateDiagnosis:'',
    deleteDiagnosis:'',
    getIncomingCall: '',
}

const masterReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_PROBLEM:
            return { ...state, addProblem: action.payload };
        case UPDATE_PROBLEM:
            return { ...state, updateProblem: action.payload };
        case GET_PROBLEM:
            return { ...state, getProblem: action.payload };
        case DELETE_PROBLEM:
            return { ...state, deleteProblem: action.payload };
        case SEARCH_PROBLEM:
            return { ...state, getProblem: action.payload };
        case ADD_DOCTOR:
            return { ...state, addDocotr: action.payload };
        case GET_DOCTOR:
            return { ...state, getDoctor: action.payload };
        case DELETE_DOCTOR:
            return { ...state, deleteDoctor: action.payload };
        case SEARCH_DOCTOR:
            return { ...state, getDoctor: action.payload };
        case UPDATE_DOCTOR:
            return { ...state, updateDoctor: action.payload };
        case ADD_MEDICAL:
            return { ...state, addMedical: action.payload };
        case GET_MEDICAL:
            return { ...state, getMedical: action.payload };
        case SEARCH_MEDICAL:
            return { ...state, getMedical: action.payload };
        case UPDATE_MEDICAL:
            return { ...state, updateMedicial: action.payload };
        case DELETE_MEDICAL:
            return { ...state, deleteMedicial: action.payload };
        case ADD_THERAPIST:
            return { ...state, addTherapist: action.payload };
        case GET_THERAPIST:
            return { ...state, getTherapist: action.payload };
        case SEARCH_THERAPIST:
            return { ...state, getTherapist: action.payload };
        case UPDATE_THERAPIST:
            return { ...state, updateTherapist: action.payload };
        case DELETE_THERAPIST:
            return { ...state, deleteTherapist: action.payload };
        case ADD_BRANCH:
            return { ...state, addBranch: action.payload };
        case GET_BRANCH:
            return { ...state, getBranch: action.payload };
        case SEARCH_BRANCH:
            return { ...state, getBranch: action.payload };
        case UPDATE_BRANCH:
            return { ...state, updateBranch: action.payload };
        case DELETE_BRANCH:
            return { ...state, deleteBranch: action.payload };
        case ADD_SERVICE:
            return { ...state, addService: action.payload };
        case GET_SERVICE:
            return { ...state, getService: action.payload };
        case SEARCH_SERVICE:
            return { ...state, getService: action.payload };
        case UPDATE_SERVICE:
            return { ...state, updateService: action.payload };
        case DELETE_SERVICE:
            return { ...state, deleteService: action.payload };
        case ADD_COUNSELOR:
            return { ...state, addCounselor: action.payload };
        case GET_COUNSELOR:
            return { ...state, getCounselor: action.payload };
        case SEARCH_COUNSELOR:
            return { ...state, getCounselor: action.payload };
        case UPDATE_COUNSELOR:
            return { ...state, updateCounselor: action.payload };
        case DELETE_COUNSELOR:
            return { ...state, deleteCounselor: action.payload };
        case ADD_PACKAGE:
            return { ...state, addPackage: action.payload };
        case GET_PACKAGE:
            return { ...state, getPackage: action.payload };
        case SEARCH_PACKAGE:
            return { ...state, getPackage: action.payload };
        case UPDATE_PACKAGE:
            return { ...state, updatePackage: action.payload };
        case DELETE_PACKAGE:
            return { ...state, deletePackage: action.payload };
        case ADMIN_USER:
            return { ...state, adminUser: action.payload };
        case ADMIN_GET:
            return { ...state, adminGet: action.payload };
        case ADMIN_SEARCH:
            return { ...state, adminGet: action.payload };
        case ADMIN_UPDATE:
            return { ...state, adminUpdate: action.payload };
        case ADMIN_DELETE:
            return { ...state, adminDelete: action.payload };       
        case ADD_DIAGNOSIS:
            return { ...state, addDiagnosis: action.payload };       
        case GET_DIAGNOSIS:
            return { ...state, getDiagnosis: action.payload };       
        case SEARCH_DIAGNOSIS:
            return { ...state, getDiagnosis: action.payload };       
        case UPDATE_DIAGNOSIS:
            return { ...state, updateDiagnosis: action.payload };       
        case DELETE_DIAGNOSIS:
            return { ...state, deleteDiagnosis: action.payload }; 
        case GET_INCOMING_CALL:           
            return { ...state, getIncomingCall: action.payload };
        case SEARCH_INCOMING_CALL:        
            return { ...state, getIncomingCall: action.payload };  
        default:
            return state;
    }
}

export default masterReducer;